import { isMediaMessage, isTextMessage } from '@whatsper/texterchat-common';
export function matchesQuickReplyDepartment(reply, department) {
    var _a;
    if (!department)
        return true;
    return !!((_a = reply.display.departments) === null || _a === void 0 ? void 0 : _a.includes(department));
}
export function matchesQuickReplySearch(reply, search) {
    var _a, _b;
    if (!search)
        return true;
    const q = search.toLowerCase();
    const titleMatch = (_a = reply.display.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(q);
    const noteMatch = (_b = reply.display.note) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(q);
    const contentMatch = reply.send.contents.some((content) => {
        var _a;
        if (isTextMessage(content)) {
            return content.text.toLowerCase().includes(q);
        }
        if (isMediaMessage(content)) {
            return (_a = content.media) === null || _a === void 0 ? void 0 : _a.some((media) => { var _a; return (_a = media.caption) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(q); });
        }
        return false;
    });
    return !!(titleMatch || noteMatch || contentMatch);
}
